module.exports = __webpack_public_path__ + "static/media/hsog_logo.892213c7.png";